import { IProjectCategory } from "@common/interfaces/projectCategory";
import { CrudService } from "../crudService";
import { Injectable } from "@angular/core";
import { ProjectCategoryQuery } from "./projectCategory.query";
import { ProjectCategoryStore } from "./projectCategory.store";
import { Topics } from "@common/interfaces/topics";
import { ActionService } from "../action/action.service";
import { BaseEntityStoreStrategy } from "../updateStoreStrategies";

@Injectable({
  providedIn: 'root',
})
export class ProjectCategoryService extends CrudService<IProjectCategory,ProjectCategoryStore,ProjectCategoryQuery> {
  constructor(
    public store: ProjectCategoryStore,
    public query: ProjectCategoryQuery,
    protected actionService: ActionService,
    protected updateStrategy: BaseEntityStoreStrategy,
  ) {
    super(
      Topics.PROJECT_CATEGORIES,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

  togglePrjCategoryExpandedProperty(categoryId: number) {
    const id: string = `${categoryId}`;
    this.store.ui.update(id, (ui) => ({
      ...ui,
      expanded: !ui.expanded
    }));
  }

}
